import { useState } from 'react';
import { toast } from 'react-toastify';
import NslMailAPI from '../../NslMailAPI';

export const useLogin = (actions) => {
    const [loginUsername, setLoginUsername] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [loggingIn, setLoggingIn] = useState(false);

    const handleLogin = async () => {
        if (!loginUsername || !loginPassword) {
            toast.error('Please enter both username and password');
            return;
        }
        
        setLoggingIn(true);
        try {
            const api = new NslMailAPI();
            // Throws on any non-200, carrying the server's message (e.g. an
            // account still awaiting approval).
            const accessToken = await api.login(loginUsername, loginPassword);

            toast.success('Login successful!');
            // Clear login form
            setLoginUsername('');
            setLoginPassword('');
            // Update the SessionContext with the new access token
            actions.setAccessToken(accessToken);
        } catch (error) {
            console.error('Login error:', error);
            toast.error(error.message || 'Invalid username or password');
        } finally {
            setLoggingIn(false);
        }
    };

    return {
        loginUsername,
        setLoginUsername,
        loginPassword,
        setLoginPassword,
        loggingIn,
        handleLogin
    };
};